/**
 * PageBody Component
 * Global page body wrapper with consistent max-width and padding
 */

import React from 'react';
import { Box } from '@mui/material';
import { PAGE_BODY } from '../../theme';

const PageBody = ({ children, sx = {}, fullWidth = false }) => {
  return (
    <Box
      sx={{
        maxWidth: fullWidth ? 'none' : { 
          xs: PAGE_BODY.maxWidth.mobile,
          sm: PAGE_BODY.maxWidth.desktop,
          md: PAGE_BODY.maxWidth.desktop,
        },
        width: '100%',
        margin: '0 auto',
        pt: `${PAGE_BODY.padding.top}px`,
        px: `${PAGE_BODY.padding.horizontal}px`,
        pb: `${PAGE_BODY.padding.bottom}px`,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default PageBody;
